import {Box} from '@mantine/core';
import {useEffect, useState} from 'react';
import {ShareButtonsForleftSideBar} from '../../../../shared/components/ShareButtonsForleftSideBar';
import {
  type ColumnSectionNameList,
  getColumnSectionNameList,
} from '../../usecases/getColumnSectionNameList';
import type {ColumnClip} from '../ArchivePage';
import {ColumnClipButton} from './ColumnClipButton';

type Props = {
  columnId: string;
  title: string;
  currentUrl: string;
  columnClip?: ColumnClip;
};

export const TableOfContents: React.FC<Props> = ({
  title,
  currentUrl,
  columnClip,
}) => {
  const [sectionNameList, setSectionNameList] = useState<ColumnSectionNameList>(
    [],
  );

  useEffect(() => {
    // GetColumnSectionNameList関数内で遷移先用のidを設定している
    setSectionNameList(getColumnSectionNameList());
  }, []);

  return (
    <Box className="">
      <div className="p-12 bg-primary-1">
        <p className="text-white text-base leading">目次</p>
      </div>
      <ul className="bg-white px-16 py-12">
        {sectionNameList.map((item, i) => (
          <li key={item.sectionName} className="pt-4 first:pt-0">
            <a
              href={`#section-${i + 1}`}
              className="text-base flex text-black hover:font-bold"
            >
              <span>{i + 1}&nbsp;</span>
              {item.sectionName}
            </a>
            {item.childSectionNameList.length > 0 && (
              <ul>
                {item.childSectionNameList?.map((child, j) => (
                  <li key={child}>
                    <a
                      href={`#section-${i + 1}-${j + 1}`}
                      className="text-base flex text-black hover:font-bold"
                    >
                      <span>
                        {i + 1}.{j + 1}&nbsp;
                      </span>
                      {child}
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
      <div className="bg-background-2 p-16">
        <ShareButtonsForleftSideBar title={title} currentUrl={currentUrl} />
        {columnClip && (
          <div className="mt-8 flex justify-center">
            <ColumnClipButton {...columnClip} />
          </div>
        )}
      </div>
    </Box>
  );
};
